'use client';

import { useMemo } from 'react';
import {
  usePathname,
  useParams,
  useSearchParams,
  useRouter as useNextRouter,
} from 'next/navigation';

type DefaultQuery = Record<string, string | string[]> | null;

// TODO: replace next route hooks by this one.
export const useRouter = <T = DefaultQuery>() => {
  const searchParams = useSearchParams();
  const params = useParams();
  const pathname = usePathname();
  const router = useNextRouter();

  const query = useMemo<T>(() => {
    const querySearchParams: DefaultQuery = {};

    searchParams?.forEach((value, key) => {
      querySearchParams[key] = value;
    });

    return { ...params, ...querySearchParams } as T;
  }, [searchParams, params]);

  return { pathname, router, query };
};
